import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Avatar, Card, Dropdown, Menu, Skeleton } from 'antd';
import { EllipsisOutlined, PhoneFilled, UserAddOutlined, VideoCameraFilled, WechatOutlined } from "@ant-design/icons";
import { FRIEND_STATUS } from "../../../constants/Friend";
import useFetch, { CachePolicies } from "use-http";
import { getNameProfile, getUrlHttp, isTrue } from "../../../service/util.service";
import { useTranslation } from "react-i18next";
import { getUserData } from "../../../service/auth.service";
import { pathRoutes } from "../../../props/util.props";
import style from "../../Modal/ProfileModal/ProfileModal.module.scss";
import blockIcon from "../../../assets/png/newIcon/My Center/Friend detail/fill/Block.png";
import reportIcon from "../../../assets/png/newIcon/My Center/Friend detail/fill/Report.png";
import moreIcon from "../../../assets/png/newIcon/My Center/Friend detail/fill/More detail.png";
import { useNavigate } from "react-router-dom";
import { AppContext } from 'src/pages/context/App.context';

const { Meta } = Card;

interface ProfileCardProps {
    userId: string
    visible: boolean
    imgURL: any
    name: any
}

export const ProfileCard: React.FunctionComponent<ProfileCardProps> = (props) => {
    const { t } = useTranslation();
    const appCtx: any = useContext(AppContext);
    const navigate = useNavigate();
    const [profile, setProfile] = useState<any>();
    const [friendStatus, setFriendStatus] = useState<FRIEND_STATUS>(FRIEND_STATUS.NOT_CONNECT)
    const [personalVideoCall, setPersonalVideoCall] = useState(false);
    const [personalVoiceCall, setPersonalVoiceCall] = useState(false);
    const [mutualGroups, setMutualGroups] = useState<any[]>([]);
    // const isObjAccess: any = localStorage.getItem("object-access");
    // let dataObjectAccesses = JSON.parse(isObjAccess);

    const apiFriends = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/friends`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const voiceTopic = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const apiUserProfile = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/users/detail`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const groupTopicAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v2/groups/topic`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const connectAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + "/api/v1/users/add-friend",
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const mutualGroupAPI = useFetch(
        window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `/api/v1/users/detail`,
        {
            cachePolicy: CachePolicies.NO_CACHE,
        }
    );

    const isMe = useMemo(() => {
        return profile?.id === getUserData()?.id
    }, [profile])

    const getMutualGroups = useCallback(async () => {
        const mutual = await mutualGroupAPI.get(`/${props.userId}`);

        setMutualGroups(mutual?.mutualGroups ? mutual?.mutualGroups : []);
    }, [props.userId])

    const connect = useCallback(async () => {
        try {
            const res = await connectAPI.post({ friendID: props.userId });
            if (connectAPI.response.ok) {
                if (res?.type === "request") {
                    setFriendStatus(FRIEND_STATUS.PENDING);
                } else if (res?.type === "accept") {
                    setFriendStatus(FRIEND_STATUS.CONNECTED);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }, [props.userId]);

    const getProfileData = async () => {
        try {
            const res = await apiUserProfile.get(`/${props.userId}`);
            const statusRes = await apiFriends.get(`?mode=add&search=${props.userId}`);

            if (apiUserProfile.response.ok) {
                setProfile(res);
            }
            if (apiFriends.response.ok) {
                const isFriend = statusRes?.data?.length !== 0;
                setFriendStatus(isFriend ? FRIEND_STATUS.CONNECTED : FRIEND_STATUS.NOT_CONNECT)
            }

        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        // if (friendStatus !== FRIEND_STATUS.CONNECTED) return;
        if (!props.visible || !props.userId) return
        getMutualGroups();
    }, [props.visible, props.userId])

    useEffect(() => {
        if (!props.visible) return
        getProfileData();
    }, [props.userId, props.visible])

    useEffect(() => {
        if (!appCtx.objectAccesses) return;
    }, [appCtx.objectAccesses]);

    const handleCall = useCallback(async (isVideoCall: boolean) => {
        const payload = {
            members: [{ userID: `${profile?.id}` }],
        };

        try {
            const res = await voiceTopic.post(payload);
            const path = `${pathRoutes.personalCall}?id=${res.id}&isVideoCall=${isVideoCall}&calleeId=${profile?.id}`
            navigate(path);

            // onRefresh?.();
            // onCancel?.();
        } catch (error) {
            console.error(error);
        }
    }, [profile]);

    const handleChat = useCallback(async () => {
        const payload = {
            members: [{ userID: `${profile?.id}` }],
        };

        try {
            const res = await groupTopicAPI.post(payload);
            navigate(pathRoutes.Chat + `?id=${res.id}`);
        } catch (error) {
            console.error(error);
        }
    }, [profile]);

    const renderActions = useMemo(() => {
        if (isMe) {
            return []
        } if (friendStatus === FRIEND_STATUS.NOT_CONNECT) {
            return [
                <UserAddOutlined style={{ fontSize: '24px' }} onClick={connect} />,
                // <Dropdown
                //     overlay={
                //         <Menu>
                //             <Menu.Item
                //                 className={style.menuItem}
                //                 onClick={() => {
                //                     // setShowConfirmBlock(true);
                //                 }}
                //             >
                //                 <div style={{ display: "flex" }}>
                //                     <img
                //                         src={blockIcon}
                //                         style={{ width: 26, height: 26 }}
                //                     />
                //                     <div className={style.textMenu}>{t("block")}</div>
                //                 </div>
                //             </Menu.Item>
                //             <Menu.Item
                //                 className={style.menuItem}
                //                 onClick={() => {
                //                     // setToReport(true);
                //                 }}
                //             >
                //                 <div style={{ display: "flex" }}>
                //                     <img
                //                         src={reportIcon}
                //                         style={{ width: 26, height: 26 }}
                //                     />
                //                     <div className={style.textMenu}>
                //                         {t("report")}
                //                     </div>
                //                 </div>
                //             </Menu.Item>
                //         </Menu>
                //     }
                //     placement="bottomCenter"
                //     arrow
                //     trigger={["click"]}
                // >
                //     <EllipsisOutlined style={{ fontSize: '24px'}} />
                // </Dropdown>

            ]
        } else if (friendStatus === FRIEND_STATUS.CONNECTED) {
            if (appCtx?.objectAccesses?.["PERSONAL_VOICE_CALL"] && appCtx?.objectAccesses?.["PERSONAL_VIDEO_CALL"]) {
                return [
                    <WechatOutlined style={{ fontSize: '24px' }} onClick={handleChat} />,
                    <PhoneFilled style={{ fontSize: '24px' }} onClick={() => handleCall(false)} />,
                    <VideoCameraFilled style={{ fontSize: '24px' }} onClick={() => handleCall(true)} />
                ]
            } else if (appCtx?.objectAccesses?.["PERSONAL_VOICE_CALL"]) {
                return [
                    <WechatOutlined style={{ fontSize: '24px' }} onClick={handleChat} />,
                    <PhoneFilled style={{ fontSize: '24px' }} onClick={() => handleCall(false)} />
                ]
            } else if (appCtx?.objectAccesses?.["PERSONAL_VIDEO_CALL"]) {
                return [
                    <WechatOutlined style={{ fontSize: '24px' }} onClick={handleChat} />,
                    <VideoCameraFilled style={{ fontSize: '24px' }} onClick={() => handleCall(true)} />
                ]
            } else {
                return [
                    <WechatOutlined style={{ fontSize: '24px' }} onClick={handleChat} />
                    // <PhoneFilled style={{ fontSize: '24px' }} onClick={() => handleCall(false)} />,
                    // <VideoCameraFilled style={{ fontSize: '24px' }} onClick={() => handleCall(true)} />,
                    // <Dropdown
                    //     overlay={
                    //         <Menu>
                    //             <Menu.Item
                    //                 className={style.menuItem}
                    //                 onClick={() => {
                    //                     // setShowConfirmBlock(true);
                    //                 }}
                    //             >
                    //                 <div style={{ display: "flex" }}>
                    //                     <img
                    //                         src={blockIcon}
                    //                         style={{ width: 26, height: 26 }}
                    //                     />
                    //                     <div className={style.textMenu}>{t("block")}</div>
                    //                 </div>
                    //             </Menu.Item>
                    //             <Menu.Item
                    //                 className={style.menuItem}
                    //                 onClick={() => {
                    //                     // setToReport(true);
                    //                 }}
                    //             >
                    //                 <div style={{ display: "flex" }}>
                    //                     <img
                    //                         src={reportIcon}
                    //                         style={{ width: 26, height: 26 }}
                    //                     />
                    //                     <div className={style.textMenu}>
                    //                         {t("report")}
                    //                     </div>
                    //                 </div>
                    //             </Menu.Item>
                    //         </Menu>
                    //     }
                    //     placement="bottomCenter"
                    //     arrow
                    //     trigger={["click"]}
                    // >
                    //     <EllipsisOutlined style={{ fontSize: '24px'}} />
                    // </Dropdown>
                ]
            }
        }
    }, [friendStatus, isMe])

    return (
        <Card
            bordered={false}
            style={{ width: 300, boxShadow: "none" }}
            actions={renderActions}
        >
            {/*<Skeleton loading={apiUserProfile.loading} avatar active>*/}
            <Meta
                // style={{ marginBottom: "1rem" }}
                avatar={<Avatar src={getUrlHttp(props.imgURL)} size={70} />}
                title={props.name}
                description={isMe ? "" : t(`In ${mutualGroups.length} groups together`)}
            // description={profile?.email}
            />
            {/*<Meta*/}
            {/*    description={`groups(${mutualGroups.length})`}*/}
            {/*/>*/}
            {/*</Skeleton>*/}
            {/*<span>{t(`In ${mutualGroups.length} groups together`)}</span>*/}
        </Card>
    )
}